// Matching control characters is the point: they are the classic filter bypass
// (`java&#9;script:`) and have no business in a path.
// eslint-disable-next-line no-control-regex
const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/;

// A redirect target supplied over the query string is only safe when it is
// unambiguously a path on the current origin. Anything carrying a scheme
// (`javascript:`, `data:`), a protocol-relative prefix (`//evil.test`) or a
// backslash the browser normalises into one (`/\evil.test`) leaves this origin.
export default function sameOriginPath(value, fallback = '/') {
    if (typeof value !== 'string') {
        return fallback;
    }
    const candidate = value.trim();
    if (!candidate.startsWith('/')) {
        return fallback;
    }
    if (candidate.startsWith('//') || candidate.startsWith('/\\')) {
        return fallback;
    }
    if (CONTROL_CHARACTERS.test(candidate)) {
        return fallback;
    }
    return candidate;
}
